var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tournament.rr.stage === _vm.ROUND_ROBIN_STAGE)?_c('RoundRobinStage'):_vm._e(),(_vm.tournament.rr.stage === _vm.BRACKETS_STAGE)?_c('BracketStage'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }